import { render, staticRenderFns } from "./souhu.vue?vue&type=template&id=0ffe9ab4&scoped=true"
import script from "./souhu.vue?vue&type=script&lang=js"
export * from "./souhu.vue?vue&type=script&lang=js"
import style0 from "./souhu.vue?vue&type=style&index=0&id=0ffe9ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe9ab4",
  null
  
)

export default component.exports